import { FieldViewModel } from "../../fields"

export function getCroppingFilter(year: number, visible: boolean) {


    return (crop: FieldViewModel) => {

        if (!crop) return false
        if (!crop.fieldVm) return false
        if (crop.fieldVm.disabled) return false
        if (visible && (!crop.visible)) return false
        if (crop.yearId != year) return false

        // Find all visible cropping in the current field and year
        const visibleCropping = crop.fieldVm.croppings
            .filter(c => (c.yearId === crop.yearId) && c.visible)
            .map(c => c.croppingId)

        // Get all next cropping which are visible according to the global filters
        const next = crop.cropping.NextCroppings.filter(c => visibleCropping.includes(c.CroppingId))

        // The current cropping is only displayed on the map
        // if it has no other visible successor
        return next.length === 0

    }

}

